export default "__VITE_ASSET__Coekvp8v__"